import React, { useState, useEffect } from 'react'
import './LoginPage.css'
import backgroundImage from '../../Assets/background4.jpg'
import hostelLogo from '../../Assets/logo.png'
import { useNavigate } from 'react-router-dom'
import { BoardingYear, BranchMaster } from '../../AllAPI/AdminAPI'
import axios from 'axios'
import { toast } from 'react-toastify'
import { VscActivateBreakpoints } from 'react-icons/vsc'
import { AiFillBuild } from 'react-icons/ai'

export default function AdminLoginPage2({ onLogin }) {
  const [campuses, setCampuses] = useState([])
  const [selectedCampus, setSelectedCampus] = useState('')
  const [loading, setLoading] = useState(false)
  const [years, setYears] = useState([])
  const [selectedYear, setSelectedYear] = useState('')

  const navigate = useNavigate()

  // ✅ Fetch campus options when page loads
  const storedBranchId = sessionStorage.getItem('branch_id')

  useEffect(() => {
    const fetchCampuses = async () => {
      try {
        const res = await axios.get(BranchMaster)
        const role = sessionStorage.getItem('role')
        let filtered = []

        if (role === 'admin' || role === 'warden') {
          filtered = res.data.filter((b) => b.branch_id == storedBranchId)

          // Auto-select campus
          if (filtered.length > 0) {
            setSelectedCampus(filtered[0].branch_id)
          }
        } else if (role === 'superintendent') {
          filtered = res.data // show all campuses
          // ✅ Auto-select first campus from list
          if (filtered.length > 0) {
            setSelectedCampus(filtered[0].branch_id)
          }
        }

        setCampuses(filtered)
      } catch (error) {
        console.error('Error fetching campuses:', error)
      }
    }

    const fetchYears = async () => {
      try {
        const res = await axios.get(BoardingYear)
        setYears(res.data)
        // ✅ Auto-select first year (if data exists)
        if (res.data.length > 0) {
          setSelectedYear(res.data[0].id)
        }
      } catch (error) {
        console.error('Error fetching years:', error)
      }
    }

    fetchCampuses()
    fetchYears()
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!selectedYear) {
      toast.error('Please select a year')
      return
    }

    // Find selected year object
    const selectedYearObject = years.find((y) => y.id == selectedYear)
    // Store selected values
    sessionStorage.setItem('selected_branch', selectedCampus)
    sessionStorage.setItem('BoardingYear', selectedYearObject.boarding_year)

    toast.success('Login completed!')

    // Mark user as fully logged in
    const role = sessionStorage.getItem('role')
    sessionStorage.setItem('username', role)

    navigate(`/${role}/dashboard`, { replace: true })
  }

  const backToLogin = () => {
    navigate('/admin/login')
    sessionStorage.clear()
  }

  return (
    <div
      className="login-background"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="row m-0">
        {/* TOP LEFT HEADER */}
        <div className="col-12">
          <div className="d-flex align-items-center">
            <img src={hostelLogo} alt="Hostel Logo" className="hostel-logo" />
            <h1 className="hostel-name">Manikbag Digambar Jain Boarding</h1>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="col-12 py-md-5">
          <div className="row p-3">
            <div className="col-12 col-md-8"></div>
            <div className="col-12 col-md-4 py-md-3 px-md-5">
              <div className="login-form-container">
                <div className="login-box pb-5">
                  <h2 className="login-title">Admin Login</h2>
                  <form onSubmit={handleSubmit}>
                    <div className="input-group">
                      <label>Select Campus</label>
                      <select
                        value={selectedCampus}
                        onChange={(e) => setSelectedCampus(e.target.value)}
                        required
                        style={{ borderRadius: '4px', height: '40px' }}
                      >
                        {campuses.map((campus) => (
                          <option
                            key={campus.branch_id}
                            value={campus.branch_id}
                          >
                            {campus.branch_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Select Year</label>
                      <select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                        required
                        style={{ borderRadius: '4px', height: '40px' }}
                      >
                        {years.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.boarding_year}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="row">
                      <div className="col-5 col-md-5">
                        <button
                          type="submit"
                          className="login-btn"
                          onClick={backToLogin}
                        >
                          Back
                        </button>
                      </div>
                      <div className="col-7 col-md-7">
                        <button
                          type="submit"
                          className="login-btn"
                          disabled={loading}
                        >
                          {loading ? 'Proceeding...' : 'Proceed'}
                        </button>
                      </div>
                    </div>
                  </form>

                  {/* <div className="bottom-links">
                    <span>
                      &copy; 2025 Jain Boarding | Managed By: TechnoAarv
                      Solution.
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="col-12">
          <footer className="footer row px-2 px-md-5">
            <div className="row m-0 p-0 footer-container">
              {/* LEFT */}
              <div className="col-12 col-md-6 footer-left">
                <div className="row m-0 p-0">
                  <div className="col-2">
                    <img
                      src={hostelLogo}
                      alt="Company Logo"
                      className="footer-logo"
                    />
                  </div>
                  <div className="col-10">
                    <h6 className=""> Dakshin Bharat Jain Sabha's </h6>
                    <h3 className="company-name">
                      {' '}
                      MANIKBAG DIGAMBAR JAIN BOARDING{' '}
                    </h3>
                  </div>
                </div>
              </div>

              {/* CENTER */}
              <div className="col-12 col-md-3 mt-3 mt-md-0 footer-center">
                <span
                  onClick={() => navigate('/terms')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}Terms & Conditions
                </span>
                <span
                  onClick={() => navigate('/privacy')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}Privacy Policy
                </span>
                <span
                  onClick={() => navigate('/student/login')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}Student Login
                </span>
                <span
                  onClick={() => navigate('/office/login')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Office Login
                </span>
              </div>

              {/* RIGHT */}
              <div className="col-12 col-md-3 mt-3 mt-md-0 footer-right">
                <h6 className="text-white pb-2">
                  Dakshin Bharat Jain Sabha's Manikbag Digambar Jain Boarding
                </h6>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} />{' '}Email: &nbsp; <span>mdjbbelgavi@gmail.com</span>
                </p>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} />{' '}Phone: &nbsp; <span>7022691008 , 9480448108</span>
                </p>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} />{' '}Address: &nbsp; Opposite Manikbag Automobiles, Old P.B Road,
                  Belagavi Karnataka 590016
                </p>
              </div>
            </div>

            <div className="footer-bottom">
              © 2025 MANIKBAG DIGAMBAR JAIN BOARDING | Managed By TechnoAarv
              Solution
            </div>
          </footer>
        </div>
      </div>
    </div>
  )
}
